import { useState } from 'react';
import { Modal, BlockStack, Text, Button } from '@shopify/polaris';
import { ASSETS } from '../config';
import './EnableEmbedVideoModal.css';

/**
 * Shared "Enable the Zelium AI app embed" help dialog with a setup video.
 * Used on the Feed page and the Dashboard's WebMCP / Store Integration cards.
 */

interface EnableEmbedVideoModalProps {
  open: boolean;
  onClose: () => void;
}

/** Controlled modal — the caller owns the open/close state. */
export function EnableEmbedVideoModal({ open, onClose }: EnableEmbedVideoModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Important: Enable the Zelium AI app embed"
      size="large"
    >
      <Modal.Section>
        <BlockStack gap="300">
          <Text as="p" variant="bodyMd">
            The <strong>Zelium AI Structured Data</strong> app embed is not enabled in your theme.
            Watch the short video below to enable it.
          </Text>
          <video
            controls
            autoPlay
            poster={ASSETS.embedVideoPoster}
            className="enable-embed-video"
            src={ASSETS.embedVideoMp4}
          >
            <track kind="captions" />
          </video>
        </BlockStack>
      </Modal.Section>
    </Modal>
  );
}

interface EnableEmbedVideoLinkProps {
  label?: string;
}

/** Self-contained plain link button that opens the video dialog. */
export function EnableEmbedVideoLink({ label = 'Watch how to enable it' }: EnableEmbedVideoLinkProps) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant="plain" onClick={() => setOpen(true)}>
        {label}
      </Button>
      <EnableEmbedVideoModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
